'use strict';
const scene = require('./storyboard-scene'),
	_ = require('underscore');
module.exports = function sceneList(listOfScenes) {
	if (!listOfScenes) {
		return undefined;
	}
	listOfScenes.findScene = function (sceneToFind) {
		if (!sceneToFind) {
			return undefined;
		}
		scene(sceneToFind);
		return _.find(listOfScenes, function (sceneInList) {
			return sceneToFind.matchesScene(sceneInList);
		});
	};
	listOfScenes.indexOfScene = function (sceneToIndex) {
		const found = sceneToIndex && listOfScenes.findScene(sceneToIndex);
		if (found) {
			return _.indexOf(listOfScenes, found);
		}
		return -1;
	};
	listOfScenes.nextSceneIndex = function () {
		const maxScene = _.max(listOfScenes, function (scene) {
			return scene && scene.index;
		});
		if (!maxScene || !maxScene.index) {
			return 1;
		}
		return maxScene.index + 1;
	};

	return listOfScenes;
};

